<template>
  <div class="standard-editor-page">
    <standard-editor
      :file-id="fileId"
      :file-name="fileName"
      :preset="preset"
      @save-requested="handleSave"
      @submit-requested="handleSubmit"
      @review-completed="handleReviewCompleted"
    />
  </div>
</template>

<script>
import StandardEditor from '@/components/StandardEditor.vue'

export default {
  name: 'StandardEditorPage',
  components: {
    StandardEditor
  },
  data() {
    return {
      fileId: '',
      fileName: '',
      preset: 'standard'
    }
  },
  created() {
    // 从路由参数中获取文件ID
    this.fileId = this.$route.params.fileId || this.$route.query.fileId || '';
    this.fileName = this.$route.query.fileName || '未命名文档';
    this.preset = this.$route.query.preset || 'standard';
    console.error(this.fileId)
    if (!this.fileId) {
      this.$message.error('缺少文件ID参数');
      // 可以选择重定向到主页或其他页面
      // this.$router.replace('/');
    }
    
    // 设置页面标题
    document.title = `${this.fileName} - 智能标准在线编辑`;
  },
  methods: {
    handleSave() {
      console.log('文档已暂存');
      this.$message.success('文档已暂存');
    },
    handleSubmit() {
      console.log('文档已提交');
      this.$message.success('文档已提交，即将返回列表页');
      
      // 延迟返回，给用户一些反馈时间
      setTimeout(() => {
        this.$router.push('/');
      }, 1500);
    },
    handleReviewCompleted(result) {
      console.log('审查完成', result);
    }
  }
}
</script>

<style scoped>
.standard-editor-page {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style> 